import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import DocumentList from '@/components/document-menu/document-list';
import PanelTitle from '@/components/document-menu/panels/panel-title';
import {Document} from '@/interfaces/document';

interface ElementProps {
  incompleteDocuments: Document[];
  pendingDocuments: Document[];
  closeMenu: () => void;
}

const PanelIncomplete: FunctionComponent<ElementProps> = ({closeMenu, incompleteDocuments, pendingDocuments}) => {
  const {t} = useTranslation();

  return (
    <>
      <PanelTitle title={t('components.document-menu.panels.incomplete.title')} />

      <DocumentList
        emptyResultMessage={t('components.document-menu.panels.incomplete.no-result-message')}
        documents={incompleteDocuments}
        onItemClick={closeMenu}
      />

      {pendingDocuments && pendingDocuments.length > 0 && (
        <>
          <hr className="mx-6 mb-8 mt-4 border-grey-450" />

          <PanelTitle title={t('components.document-menu.panels.incomplete.pending.title')} />

          <DocumentList
            emptyResultMessage={t('components.document-menu.panels.incomplete.pending.no-result-message')}
            documents={pendingDocuments}
            onItemClick={closeMenu}
            linksDisabled
          />
        </>
      )}
    </>
  );
};

export default PanelIncomplete;
